import React from 'react';
import { CtaButton } from './ui/CtaButton';
export function FinalCtaSection() {
  return <section id="final" className="w-full bg-[#0f172a] py-24 sm:py-32" aria-labelledby="cierre-title" data-id="element-38" data-mp="3lu6hnkg7bqm4">
      <div className="mx-auto w-full max-w-3xl px-6 text-center" data-id="element-39" data-mp="3qszwbg785nnv">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500" data-id="element-40" data-mp="3qrgidw91jop9">
          La Decisión
        </p>
        <h2 id="cierre-title" className="mt-6 font-serif text-3xl font-bold leading-[1.15] text-white sm:text-5xl" data-id="element-41" data-mp="2y542cj91i9us">
          El mismo dinero. El mismo tiempo. Un sistema{' '}
          <span className="text-[#22c55e]" data-id="element-42" data-mp="331m214piji09">diferente</span>.
        </h2>
        <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-slate-400" data-id="element-43" data-mp="381gqz2pq9xio">
          Mañana vas a desayunar. El único a lo que podés cambiar es si ese desayuno
          forma parte de un sistema que trabaja a tu favor o uno que trabaja en tu
          contra.
        </p>

        <div className="mt-12 flex flex-col items-center" data-id="element-44" data-mp="2kc60ce23dji9">
          <CtaButton label="Adquirir Mega Pack Ahora!" href="#comprar" data-id="element-45" data-mp="2dbqld2v30zu6" />
          <p className="mt-4 text-xs tracking-wide text-slate-500" data-id="element-46" data-mp="2ddunpgdc1qsc">
            Garantía 7 días · Acceso inmediato · Precio de lanzamiento
          </p>
        </div>
      </div>
    </section>;
}